import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

function loadLocaleMessages() {
    const locales = require.context(
        './locales',
        true,
        /[A-Za-z0-9-_,\s]+\.json$/i
    );
    const messages = {};
    locales.keys().forEach((key) => {
        const matched = key.match(/([a-z0-9]+)\./i);
        if (matched && matched.length > 1) {
            const locale = matched[1];
            messages[locale] = locales(key);
        }
    });
    return messages;
}

function checkNavigatorLanguage() {
    let availiableLanguages = process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(',');
    if (availiableLanguages.includes(navigator.language)) {
        return navigator.language;
    } else {
        return process.env.VUE_APP_I18N_FALLBACK_LOCALE
    }
}

export default new VueI18n({
    locale: checkNavigatorLanguage(),
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'es',
    messages: loadLocaleMessages(),
});
